import { useState } from "react";

export function useToggle(initialValue = false): [boolean, () => void] {
  const [value, setValue] = useState(initialValue);

  const handleToggle = () => {
    setValue((prevValue) => !prevValue);
  };

  return [value, handleToggle];
}
